import UserProfile from "components/workflows/UserProfile.component";
import {useTranslation} from "components/translations/useTranslation";
import {ApproversTableProps, CurrentWorkflowStepProps} from "types/newWorkflowDetails";
import {assignmentReasons} from "./workflowDetails.function";

const ApproversTable = ({title, assignments, completed}: ApproversTableProps) => {
    const {translate} = useTranslation();

    return (
        <div className="current-step__approvers">
            <div className="current-step__row current-step__row--header">
                <span className="current-step__approver">{title}</span>
                <span>{translate("taskDetail.reason")}</span>
            </div>
            {assignments.map((assignment) => {
                const [reason, previousReason] = assignmentReasons(assignment);
                return (
                    <div className="current-step__row" key={assignment.userDTO.idUser}
                         data-cy="workflowDetails.currentStepApprover">
                        <span className="current-step__approver">
                            <UserProfile user={assignment.userDTO}
                                         uniqueKey={`current-step-${completed ? "completed" : "incomplete"}`}/>
                        </span>
                        <span className="current-step__reason">
                            {reason}
                            {previousReason && <span className="current-step__previous-reason">{previousReason}</span>}
                        </span>
                    </div>
                );
            })}
        </div>
    );
}

// The former "Current workflow step" section, now shown inside the step that is in process
export function CurrentWorkflowStep({step}: CurrentWorkflowStepProps) {
    const {translate} = useTranslation();

    return (
        <div className="current-step" data-cy="workflowDetails.currentStep">
            <div className="current-step__header">
                <span className="current-step__title">{translate("taskDetail.currentWorkflowStep")}</span>
                <span className="current-step__status">{translate("taskDetail.awaitingApproval")}</span>
            </div>
            {step.incompleteAssignments.length > 0 &&
                <ApproversTable title={translate("taskDetail.currentApprovers")}
                                assignments={step.incompleteAssignments}
                                completed={false}/>}
            {step.completedAssignments.length > 0 &&
                <ApproversTable title={translate("taskDetail.pastApprovers")}
                                assignments={step.completedAssignments}
                                completed={true}/>}
        </div>
    );
}

export default CurrentWorkflowStep;
